import { GeneralConditionEntity } from './GeneralConditionEntity';

export class VendorGeneralConditionEntity extends GeneralConditionEntity {
  constructor(entity?: VendorGeneralConditionEntity) {
    super(entity);
  }
}
